import { actions } from 'state/current-user/current-user.slice';
import type { CurrentUserData } from 'state/current-user/current-user.slice';

import type { UserDto } from 'api/generated/schemas/userDto';

import { getCurrentAccount } from 'api/generated/users/users';

import type { AppThunk } from 'state/store';

import { getOktaUserId } from 'helpers/okta-session';

const { setCurrentUser, loadingCurrentUserFailed, loadingCurrentUser } =
  actions;

interface ClientsHook {
  find: (id: string | number) => Promise<{ data: Record<string, unknown> }>;
}

const mapGeneratedUserDtoToCurrentUserData = (
  dto: UserDto
): CurrentUserData => {
  const base: Record<string, unknown> = { ...dto };

  base.id = dto.id ?? '';
  base.oktaUserId = dto.oktaUserId ?? '';

  return base as CurrentUserData;
};

export const currentUserInfoAction =
  (clientsHook: ClientsHook): AppThunk<Promise<unknown>> =>
  (dispatch, getState) => {
    dispatch(loadingCurrentUser());

    const state = getState();
    const currentUserState = state.currentUser as {
      id: string | number | null;
      data: CurrentUserData | null;
    };

    if (currentUserState.id && currentUserState.data) {
      dispatch(setCurrentUser(currentUserState.data));

      return Promise.resolve(currentUserState.data);
    }

    const oktaUserId = getOktaUserId();

    if (!oktaUserId) {
      const err = new Error('No Okta session for current user request');

      dispatch(loadingCurrentUserFailed(err));

      return Promise.reject(err);
    }

    return getCurrentAccount(oktaUserId)
      .then(async (userData) => {
        // While we're here, grab the client, so we can get the user's consultants
        if (userData.client?.id !== undefined && userData.client?.id !== null) {
          return clientsHook.find(userData.client.id).then((client) => {
            const stored = mapGeneratedUserDtoToCurrentUserData(userData);

            const merged: CurrentUserData = {
              ...stored,
              client: client.data as CurrentUserData['client'],
            };

            dispatch(setCurrentUser(merged));

            return merged;
          });
        }

        const stored = mapGeneratedUserDtoToCurrentUserData(userData);

        dispatch(setCurrentUser(stored));

        return stored;
      })
      .catch((e: unknown) => {
        dispatch(loadingCurrentUserFailed(e));
      });
  };
